// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* .asset-summary-buttons2 {
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
  justify-content: flex-start; /* Aligns items to the left 
  margin-top: 30px;
  padding: 0;         /* Removes internal space 
  margin-top: 30px;
  margin-left:60px; 
} */
 .assets-required-asterisk {
  color: red!important;
  font-weight: lighter;
  margin-left: 2px;
}
.error-message {
  color: red!important;
  font-size: 12px;
  margin-top: 4px;
  display: block;
}
.asset-summary-buttons2 {
  display: flex;
  justify-content: space-between; /* Left group + right button */
  align-items: center;
  flex-wrap: wrap;
  gap: 20px;
  margin: 30px 60px 0 0px;
  padding: 0;
}
.assetsmain-close-btn-addasset {
  background: none;
  border: none;
  cursor: pointer;
  position: absolute;
  top: 12px;
  right: 12px;
  padding: 0;
}

.assetsmain-close-popup-icon {
  font-size: 24px;
  color: #fff;
  transition: color 0.3s ease;
}

.assetsmain-close-popup-icon:hover {
  color: red;
}


.close-button-assign-asset {
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  display: flex;
  align-items: center;
}

.assign-close-popup-icon {
  font-size: 24px;
  color: #fff;
  transition: color 0.3s ease;
}

.assign-close-popup-icon:hover {
  color: red;
}




.left-buttons {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  margin-top:5%;
}

.right-button {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top:5%;
  padding:10px 12px;
}
.add-assets-btn {
  background-color: #7FBD2C;
  color: white;
  padding: 10px 12px;
  border: none;
  cursor: pointer;
  font-size: 13px;
  border-radius: 6px;
  height: 34px;
  display: flex;
  align-items: center;
  gap: 5px;
}

.asset-summary-container {
  max-width: 50%;
  padding: 10px;
  box-sizing: border-box;
  margin-left: auto; /* moves it to the right */
  margin-right: 0px; /* optional spacing from the right edge */
}



.category-button-wrapper {
  position: relative;
}

.category-button {
  padding: 12px 20px;
  background-color: white;
  color: rgb(31, 24, 24);
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-weight: 500;
  font-size: 16px;
  transition: background-color 0.3s;
}
.total-assets-box {
  font-size: 16px;
  font-weight: 500;
  padding: 6px 12px;
  border: 1px solid #7FBD2C;
  background-color: #f1fae8;
  border-radius: 6px;
  color: rgb(31, 24, 24);
  height: 30px;
  display: flex;
  align-items: center;
}
.category-button:hover {
  background-color: #7FBD2C;
}

/* Tooltip for Subcategories */
.subcategory-tooltip {
  position: absolute;
  top: 100%;
  left: 0;
  margin-top: 8px;
  background-color: rgb(228, 235, 230);
  color: black;
  border: 1px solid #ccc;
  border-radius: 6px;
  padding: 10px;
  box-shadow: 0 2px 6px rgba(0,0,0,0.15);
  display: none;
  white-space: nowrap;
  z-index: 40;
}

.category-button-wrapper:hover .subcategory-tooltip {
  display: block;
}

.subcategory-item {
  padding: 4px 8px;
  font-size: 14px;
}

.assets-container {
  max-width: 1200px;  /* You can reduce this to 800px or 600px as needed */
  margin: 0 auto;      /* Centers the container */
  padding: 0px;       /* Smaller padding */
  border-radius: 8px;
}


/* Style for the caption container */
.table-caption {
  caption-side: top;
  padding: 10px;
  text-align: left;
  display: flex;
  align-items: center;
  gap: 10px;
}

/* Label styling */
.asset-table-search-label {
  font-weight: 600;
  font-size: 14px;
  margin-right: 8px; /* 👈 adds space between label and input */

}

/* Input box styling */
.asset-table-search-input {
  padding: 10px 10px;
  font-size: 14px;
  border-radius: 4px;
  border: 1px solid #ccc;
  width: 200px;
  outline: none;
  transition: border-color 0.2s ease-in-out;
}

.asset-table-search-input:focus {
  border-color: #28a745; /* soft green border on focus */
}
.asset-search-container {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 10px;
  margin-top:20px;
  margin-bottom:-30px;
  margin-left:-10px;
}




.asset-popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.4);
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center;
}

.asset-popup-content {
  background: #E8E9EA;
  padding: 20px;
  border-radius: 10px;
  width: 600px;
  max-width: 90%;
  max-height: 90vh;
  overflow-y: auto;
  position: relative;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
}



.asset-popup-header {
  background-color: #00468C;
  color: white;
  padding: 12px 20px;
  font-size: 20px;
  font-weight: bold;
  text-align: center;
  margin: -20px -20px 20px -20px; /* negative margins to cancel out container padding */
  border-radius: 8px 8px 0 0;
}

/* Sticky Options (Main Categories) */
.sticky-options {
display: flex;
justify-content: space-around;
width: auto;
padding: 12px 0;
font-size: 18px;
}

.sticky-options button {
display: flex; /* Ensure the icon and text align properly */
align-items: center; /* Vertically center items */
justify-content: center; /* Center icon and text */
gap: 8px; /* Space between icon and text */

flex: 1 1; /* Make all buttons take equal space */
text-align: center;
padding: 12px 24px; /* Increase padding */
font-size: 18px;
background: #d3d3d3;

border: none;
cursor: pointer;
font-weight: bold;
border-bottom: 3px solid black;
border-radius: 5px;
transition: all 0.2s ease-in-out;
min-width: 150px; /* Set a minimum width */
}

.sticky-options button:hover {
background: #b3b3b3;
}

.icon {
width: 24px; /* Adjust icon size */
height: 24px;
}
.icon-group {
display: flex;
justify-content: center;
gap: 10px; /* Space between multiple icons */
margin-bottom: 5px;
}

.asset-details-grid {
  display: flex;
  flex-direction: column;
  gap: 15px; /* Space between rows */
  margin-top: 15px;
  max-width: 600px; /* Adjust width */
}

/* Each row has label and input */
.row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px; /* Space between label and input */
}

/* Style labels */
.row label {
  font-weight: bold;
  width: 150px; /* Adjust label width */
  text-align: right; /* Align text to right */
}

/* Ensure input fields align properly */
.row input {
  flex: 1 1; /* Inputs take available space */
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
}


.sticky-options button.active {
  border-bottom: none; /* Remove bottom border when active */
  background: #b0b0b0; /* Darker gray when active */
}

/* Sub-options (without box, only underline when active) */
.sticky-suboptions {
display: flex;
justify-content: space-around;
padding: 10px 0;
}

.sticky-suboptions button {
background: none;
border: none;
font-size: 16px;
cursor: pointer;
position: relative;
padding-bottom: 5px;
font-weight: bold;
}

.sticky-suboptions button.active::after {
content: "";
display: block;
width: 100%;
height: 3px;
background-color: black;
position: absolute;
bottom: 0;
left: 0;
}
.sticky-suboptions button .icon {
  width: 20px; /* Adjust as needed */
  height: 20px;
}
/* Asset Details */
.asset-details input {
  display: block;
  width: 100%;
  margin: 12px 0;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
}

.popup-buttons {
display: flex;
justify-content: flex-end;  /* Moves buttons to the right */
align-items: flex-end;      /* Aligns buttons at the bottom */
padding: 15px;
gap: 10px;  /* Adds spacing between buttons */
bottom: 10px;  /* Ensures it's at the bottom */
right: 10px;   /* Ensures it's aligned to the right */
width: 98%;   /* Ensures full width for spacing */
}

.cancel-btn {
  background-color: #ddd;
  color: rgb(14, 7, 7);
  padding: 10px 18px;
  border: 1px solid #7FBD2C; /* Grid lines */
  border-radius: 5px;
  cursor: pointer;
  font-size: 16px;
}

.save-btn {
  background-color: #7FBD2C;
  color: white;
  padding: 10px 18px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-size: 16px;
}

.close-btn-addasset {
  position: absolute;
  top: 10px;
  right: 30px;
  background: transparent;
  border: none;
  font-size: 24px;
  font-weight: bold;
  color: white;
  cursor: pointer;
  z-index: 1000;
}

.close-btn-addasset:hover {
  color: #000;
}

/* Assets Table Container */
/* Assets Table Container */
.assets-table {
width: 100%;
max-width: 100%;
margin: 20px auto;
background: #f9f9f9;
border-radius: 10px;
box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
max-height: 450px; /* Adjust height */
position: relative;
border: 1px solid #ddd;
}

/* Table Styling */
.assets-table table {
  table-layout: fixed; /* Prevents columns from resizing based on content */
width: 100%;
border-collapse: collapse;
background-color: white;
border-radius: 8px;
table-layout: auto; /* Ensures correct column width */
}
.assets-table-wrapper {
  margin-top:20px;
  max-height: 300px; /* Adjust height as needed */
  overflow-y: auto;
  overflow-x: hidden; /* Prevent horizontal scrolling */
}
/* Specific styling for Asset Name and Configuration columns */
.assets-table th:nth-child(3), /* Asset Name header */
.assets-table td:nth-child(3), /* Asset Name cell */
.assets-table th:nth-child(4), /* Configuration header */
.assets-table td:nth-child(4) { /* Configuration cell */
  max-width: 150px; /* Set a fixed maximum width */
  min-width: 150px; /* Ensure consistent width */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  position: relative; /* For tooltip positioning */
}

/* Tooltip for full text on hover */
.assets-table td:nth-child(3):hover::after,
.assets-table td:nth-child(4):hover::after {
  content: attr(data-full-text); /* Use data attribute for full text */
  position: absolute;
  top: 100%; /* Display below the cell */
  left: 0;
  background-color: #333;
  color: white;
  padding: 8px;
  border-radius: 4px;
  z-index: 10;
  white-space: normal; /* Allow text wrapping in tooltip */
  max-width: 300px; /* Limit tooltip width */
  word-wrap: break-word; /* Break long words */
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}
/* Sticky Header */
.assets-table thead {
background-color: white;
color: black;
font-weight: bold;
position: sticky;
top: 0;  /* Stick to top */
z-index: 10; /* Ensure it's above content */
}

.assets-table {
  width: 100%;
  border-collapse: collapse; /* Ensures single borders */
}

.assets-table th,
.assets-table td {
  border: 1px solid #ccc; /* Apply border to all cells */
}

.assets-table th {
  padding: 12px;
  text-align: center;
  font-size: 12px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  background-color: #f9f9f9; /* Optional: better visual distinction */
}

/* Scrollable Body */
.assets-table tbody {
overflow-y: auto; /* Enables vertical scrolling */
max-height: 400px;
}

/* Table Body Rows */
.assets-table tbody tr {
transition: background 0.3s ease;
}

.assets-table tbody tr:nth-child(even) {
background-color: #f2f2f2; /* Alternating row color */
}

.assets-table tbody tr:hover {
background-color: #e0e0e0;
}

/* Table Data Cells */
.assets-table td {
padding: 3px;
text-align: center;
font-size: 12px; /* Reduced font size */
border: 1px solid #ccc; /* Grid lines */
white-space: nowrap; /* Prevents wrapping */
overflow: hidden;
text-overflow: ellipsis;
}

/* No Border for Certain Cells */
.assets-table .no-border {
border: none;
}

/* Assign Button */
.assets-table .assign-btn {
background-color: #007bff;
color: white;
padding: 5px 10px;
font-size: 12px;
font-weight: bold;
border-radius: 5px;
border: none;
cursor: pointer;
transition: 0.3s;
}

.assets-table .assign-btn:hover {
background-color: #0056b3;
}

/* View Document Button */
.assets-table button {
background-color: #7FBD2C; /* Green */
color: white;
padding: 5px 10px;
font-size: 12px;
font-weight: bold;
border-radius: 5px;
border: none;
cursor: pointer;
transition: 0.3s;
}

.assets-table button:hover {
background-color: #7FBD2C;
}

/* No Assets Available Row */
.assets-table td[colspan="7"] {
text-align: center;
font-style: italic;
color: #777;
padding: 15px;
}
/* Assigned To Column */
/* Assigned To Column */
.assigned-to-cell {
display: flex;
align-items: center;
justify-content: space-between; /* Keep name & button aligned */
gap: 10px;
min-width: 200px;  /* Adjust this value if needed */
max-width: 300px;  /* Prevent excessive stretching */
white-space: nowrap;
overflow: hidden;
}

/* Assigned To Name */
.assigned-name {
flex-grow: 1;
max-width: 70%; /* Ensures name does not take up too much space */
white-space: nowrap;
overflow: hidden;
text-overflow: ellipsis; /* Adds "..." if name is too long */
}

/* Assign Button */
.assign-btn {
flex-shrink: 0;  /* Prevents button from shrinking */
min-width: 80px;
padding: 5px 10px;
font-size: 12px;
font-weight: bold;
background-color: #007bff;
color: white;
border: none;
border-radius: 5px;
cursor: pointer;
}




.assign-btn:hover {
background-color: #0056b3;
}

/* Responsive Table */



/* Assigned Assets Container */
.assigned-assets-container {
width: 100%;
max-width: 1200px;
margin: 20px auto;
padding: 20px;
background: #f9f9f9;
border-radius: 10px;
box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
}

/* Table Styling */
.assigned-assets-table {
width: 100%;
border-collapse: collapse; /* Ensures grid lines appear correctly */
background-color: white;
border-radius: 8px;
overflow: hidden;
box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.1);
border: 2px solid #ddd; /* Outer border */
}

/* Table Header */
.assigned-assets-table thead {
background-color: #00468C;
color: white;
font-weight: bold;
}

/* Table Header and Cells */
.assigned-assets-table th,
.assigned-assets-table td {
padding: 12px;
text-align: left;
border: 1px solid #ccc; /* Grid lines */
}

/* Table Body Rows */
.assigned-assets-table tbody tr {
transition: background 0.3s ease;
}

.assigned-assets-table tbody tr:hover {
background-color: #f1f1f1;
}

/* Button Styling */
.assigned-assets-table button {
background-color: #28a745;
color: white;
padding: 8px 12px;
border: none;
border-radius: 5px;
cursor: pointer;
font-weight: bold;
transition: 0.3s;
}

.assigned-assets-table button:hover {
background-color: #218838;
}

/* No Assigned Assets Row */
.assigned-assets-table td[colspan="7"] {
text-align: center;
font-style: italic;
color: #777;
padding: 15px;
}

.no-data {
  text-align: center;
  padding: 20px;
  font-size: 16px;
  color: gray;
}
/* Adjust dropdown box size */
.asset-status-dropdown {
flex: 1 1;
display: flex;
}

.asset-status-dropdown select {
width: 100%;
padding: 10px;
border: 1px solid #ccc;
border-radius: 4px;
background: white;
font-size: 16px;
}





/* Overlay to cover the whole screen */
.assignpopup-overlay {
position: fixed;
top: 0;
left: 0;
width: 100%;
height: 100%;
background: rgba(0, 0, 0, 0.5);
display: flex;
justify-content: center;
align-items: center;
z-index: 1000;
overflow: hidden; /* Prevents background scrolling */
}

/* Popup content with increased width and scrolling */
.assignpopup-content {
background: #E8E9EA;
width: 1000px; /* Increased width */
max-width: 95%; /* Ensures it fits smaller screens */
max-height: 50vh; /* Set max height to avoid cutting */
padding: 20px;
border-radius: 0px;
box-shadow: 0 4px 10px rgba(0, 0, 0, 0.3);
position: relative;
text-align: left;
overflow-y: auto; /* Enable scrolling */
}
.assignpopup-content h3 {
background-color: #00468C;
padding: 12px;
color: white;
font-size: 20px;
text-align: center;
font-weight: bold;
margin-bottom: 15px;

/* Make the header stretch across the top */
margin: -20px -20px 15px -20px; /* Pull edges to touch the sides */
padding: 15px; /* Increase padding for better spacing */

/* Rounded bottom corners only */
border-radius: 0px;
}

/* Grid layout for form */
.assetform-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr); /* Two columns */
  gap: 20px; /* Space between fields */
  margin-bottom: 10px;
}

.assetform-field {
  display: flex;
flex-direction: column;
gap: 5px; /* Space between label and input */
margin-bottom: 10px; /* Space between form fields */
}
/* Styling the label */
.assetform-field label {
font-weight: bold;
font-size: 14px;
color: #333;
}

/* Styling the input fields, select, and textarea */
.assetform-field input,
.assetform-field select,
.assetform-field textarea {
padding: 10px;
border: 1px solid #ccc;
border-radius: 5px;
font-size: 14px;
transition: border 0.3s ease-in-out;
}

/* Add hover effect */
.assetform-field input:hover,
.assetform-field select:hover,
.assetform-field textarea:hover {
border-color: #00468C;
}

/* Focus effect */
.assetform-field input:focus,
.assetform-field select:focus,
.assetform-field textarea:focus {
border-color: #00468C;
outline: none;
box-shadow: 0 0 5px rgba(0, 70, 140, 0.3);
}

/* Make textarea slightly larger */
.assetform-field textarea {
height: 80px;
resize: vertical;
}
/* Full-width fields (for comments) */
.assetform-field.full-width {
  grid-column: span 2; /* Makes it take the full width */
}

/* Row for asset details */
.row {
  display: flex;
  justify-content: space-between;
  gap: 15px;
  margin-bottom: 10px;
}

.row p {
  font-weight: bold;
  margin: 0;
}

/* Styling inputs */
.form-field input,
.form-field select,
.form-field textarea {
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 5px;
  width: 100%;
}

/* Make textarea slightly taller */
.form-field textarea {
  height: 80px;
}
.close-button-assign-asset {
  position: absolute;
  top: 10px;
  right: 15px;
  background: transparent;
  border: none;
  font-size: 24px;
  color: white;
  cursor: pointer;
  z-index: 1001;
}

.close-button-assign-asset:hover {
  color: #ffcccc;
}




/* Ensure the table inside the popup also scrolls properly */
.assigned-assets-container {
max-height: 350px; /* Increase the table height */
overflow-y: auto; /* Make it scrollable */
border: 1px solid #ddd;
border-radius: 5px;
}

/* Row-wise alignment for form fields */
.row {
display: flex;
align-items: center;
justify-content: space-between;
gap: 15px;
margin-bottom: 10px;
}

.row label {
font-weight: bold;
width: 150px; /* Increased label width */
}

.row input,
.row select,
.row textarea {
flex: 1 1;
padding: 8px;
border: 1px solid #ccc;
border-radius: 5px;
width: calc(100% - 160px); /* Adjust width for better alignment */
}

/* Buttons */
.assignpopup-buttons {
display: flex;
justify-content: flex-end;
gap: 10px;
margin-top: 25px;
margin-bottom:10px;
margin-right:50px;
}
.decommissioned-row {
  background-color: #504444 !important;
}

.assignpopup-buttons button {
padding: 8px 12px;
border: none;
cursor: pointer;
border-radius: 5px;
font-size: 14px;
border: 1px solid #7FBD2C; /* Black border */

}

.assigncancel-btn {
background-color: #ccc;
border: 2px solid black; /* Black border */

}

.assignsave-btn {
background-color: #7FBD2C;
color: white;
}



.assetform-row {
display: flex;
gap: -10px;
margin-bottom: 10px;
align-items: flex-start;
flex-wrap: wrap;
}

.assetform-row input,
.assetform-row select,
.assetform-row textarea {
flex: 1 1;
min-width: 150px;
}

.addrow-btn {
margin: 10px 0;
padding: 6px 12px;
background-color: #7FBD2C;
color: white;
border: none;
cursor: pointer;
border-radius: 5px;
}

.assetform-header,
.assetform-row {
display: grid;
grid-template-columns: 150px 150px 150px 150px 200px; /* One column per field */
gap: 30px;
margin-bottom: 10px;
align-items: center;
}

.assetform-header {
font-weight: bold;
padding: 8px;
border-radius: 5px;
}

.assetform-row input,
.assetform-row select,
.assetform-row textarea {
width: 100%;
padding: 6px;
font-size: 14px;
border: 1px solid #ccc;
border-radius: 4px;
}

.assetform-row textarea {
resize: none;
height: 30px;
}






.returndateform-container h3 {
background-color: #00468C; /* Set background color */
color: white; /* Set text color */
padding: 10px; /* Add padding */
text-align: center; /* Center the text */
border-radius: 5px; /* Add rounded corners */
margin-bottom: 15px; /* Add space below */
}






/* Return Date Form Container */
.returndateform-container {
background-color: #E8E9EA;
padding: 20px;
border-radius: 0px;
box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
max-width: 400px;
width: 100%;
margin: auto;
text-align: center;
border: 1px solid #ddd;
position: fixed;
top: 50%;
left: 50%;
transform: translate(-50%, -50%);
z-index: 1000;
}

/* Form Heading */
.returndateform-container h3 {
background-color: #00468C;
color: white;
padding: 12px;
border-radius: 0px;
font-size: 18px;
text-align: center;
font-weight: bold;
margin-bottom: 15px;
}

/* Form Fields */
.returndateform-container form {
display: flex;
flex-direction: column;
gap: 15px;
}

/* Labels */
.returndateform-container label {
font-weight: bold;
font-size: 14px;
color: #333;
text-align: left;
display: block;
margin-bottom: 5px;
}

/* Input Fields */
.returndateform-container input {
padding: 10px;
border: 1px solid #ccc;
border-radius: 5px;
font-size: 14px;
width: 95%;
transition: border 0.3s ease-in-out;
}

/* Input Focus & Hover Effects */
.returndateform-container input:hover {
border-color: #00468C;
}

.returndateform-container input:focus {
border-color: #00468C;
outline: none;
box-shadow: 0 0 5px rgba(0, 70, 140, 0.3);
}



/* Parent container should have relative positioning */


/* Buttons Container - Positioned Bottom Right */
.returndateform-buttons {
display: flex;
flex-direction: row; /* Keeps buttons in a row */
justify-content: flex-end; /* Aligns buttons to the right */
align-items: center;
gap: 10px; /* Space between buttons */
bottom: 15px;
right: 15px;
}

/* Save Button */
.returndateform-buttons .rsave-btn {
background-color: #28a745; /* Green */
color: white;
padding: 10px 20px;
font-size: 14px;
font-weight: bold;
border-radius: 5px;
border: none;
cursor: pointer;
transition: 0.3s;
min-width: 100px;
text-align: center;
}

.returndateform-buttons .rsave-btn:hover {
background-color: #218838;
}

/* Cancel Button */
.returndateform-buttons .rcancel-btn {
background-color: #dfd9da; /* Light Grey */
color: rgb(22, 6, 6);
padding: 10px 20px;
font-size: 14px;
font-weight: bold;
border-radius: 5px;
border: 1px solid rgb(29, 119, 37); /* Black border */
cursor: pointer;
transition: 0.3s;
min-width: 100px;
text-align: center;
}

.returndateform-buttons .rcancel-btn:hover {
background-color: #c0b6b8; /* Slightly darker on hover */
}


/* Asset Summary Container */
.asset-summary {
width: 100%;
max-width: 90%;
margin: 20px auto;
padding: 20px;
background: #f9f9f9;
border-radius: 10px;
box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
overflow-x: auto; /* Enables horizontal scrolling if needed */
text-align: center;
}

/* Title */
.asset-summary h2 {
text-align: center;
font-size: 22px;
color: #00468C;
margin-bottom: 15px;
}

/* Table Styling */
.asset-summary table {
width: 100%;
border-collapse: collapse; /* Ensures proper grid lines */
background-color: white;
border-radius: 8px;
overflow: hidden;
box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.1);
border: 2px solid #ddd; /* Outer border */
}

/* Table Header */
.asset-summary thead {
background-color: #00468C; /* Dark blue header */
color: white;
font-weight: bold;
}

.asset-summary th {
padding: 12px;
text-align: center;
border: 1px solid #ccc; /* Grid lines */
}

/* Table Body Rows */
.asset-summary tbody tr {
transition: background 0.3s ease;
}

.asset-summary tbody tr:nth-child(even) {
background-color: #f2f2f2; /* Alternating row color */
}

.asset-summary tbody tr:hover {
background-color: #e0e0e0;
}

/* Table Data Cells */
.asset-summary td {
padding: 12px;
text-align: center;
border: 1px solid #ccc; /* Grid lines */
font-size: 16px;
font-weight: 500;
color: #333;
}

/* No Data Available Row */
.asset-summary td[colspan="5"] {
text-align: center;
font-style: italic;
color: #777;
padding: 15px;
}



/* Mobile Responsive */
@media (max-width: 768px) {
.assignpopup-content {
  width: 95%;
  max-height: 85vh;
}

.row {
  flex-direction: column;
  align-items: flex-start;
}

.row label {
  width: 100%;
}
}

.no-border {
border: none !important;
background: transparent !important;
}


.no-border {
display: flex;          /* Makes items appear in one row */
align-items: center;    /* Aligns text and button vertically */
gap: 10px;             /* Adds space between name and button */
white-space: nowrap;   /* Prevents wrapping */
}

.assign-btn {
padding: 5px 10px;
background-color: #007bff; /* Blue background */
color: white;
border: none;
border-radius: 5px;
cursor: pointer;
transition: background 0.3s ease;
}

.assign-btn:hover {
background-color: #0056b3; /* Darker blue on hover */
}

.assign-btn:active {
background-color: #004494; /* Even darker blue when clicked */
}

.view-doc-btn {
display: flex;
align-items: center;
gap: 5px; /* Space between icon and text */
background-color: #28a745; /* Green */
color: white;
padding: 5px 10px;
font-size: 12px;
font-weight: bold;
border-radius: 5px;
border: none;
cursor: pointer;
transition: 0.3s;
}

.view-doc-btn:hover {
background-color: #218838;
}



.editassign-btn {
display: flex;
align-items: center;
gap: 5px; /* Space between icon and text */
background-color: #007bff;
color: white;
padding: 5px 10px;
font-size: 12px;
font-weight: bold;
border-radius: 5px;
border: none;
cursor: pointer;
transition: 0.3s;
}

.editassign-btn:hover {
background-color: #0056b3;
}


.input-style {
  padding: 6px;
  border-radius: 4px;
  border: 1px solid #ccc;
}

.error-border {
  border: 1px solid red;
  background-color: #ffe6e6;
}
.view-doc-btn, .download-doc-btn {
  background-color: #00468C;
  color: white;
  border: none;
  padding: 6px 10px;
  border-radius: 4px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
}

.download-doc-btn {
  background-color: #007B3A; /* Slightly different color for download */
}
`, "",{"version":3,"sources":["webpack://./src/components/Assets/assets.css"],"names":[],"mappings":"AAAA;;;;;;;;;GASG;CACF;EACC,oBAAoB;EACpB,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,oBAAoB;EACpB,eAAe;EACf,eAAe;EACf,cAAc;AAChB;AACA;EACE,aAAa;EACb,8BAA8B,EAAE,8BAA8B;EAC9D,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,uBAAuB;EACvB,UAAU;AACZ;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,WAAW;EACX,2BAA2B;AAC7B;;AAEA;EACE,UAAU;AACZ;;;AAGA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,UAAU;EACV,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,2BAA2B;AAC7B;;AAEA;EACE,UAAU;AACZ;;;;;AAKA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,aAAa;AACf;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,iBAAiB;AACnB;AACA;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,iBAAiB,EAAE,0BAA0B;EAC7C,iBAAiB,EAAE,yCAAyC;AAC9D;;;;AAIA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iCAAiC;AACnC;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,yBAAyB;AAC3B;;AAEA,8BAA8B;AAC9B;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,eAAe;EACf,oCAAoC;EACpC,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,sCAAsC;EACtC,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,iBAAiB,GAAG,oDAAoD;EACxE,cAAc,OAAO,0BAA0B;EAC/C,YAAY,QAAQ,oBAAoB;EACxC,kBAAkB;AACpB;;;AAGA,oCAAoC;AACpC;EACE,iBAAiB;EACjB,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA,kBAAkB;AAClB;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB,EAAE,0CAA0C;;AAE/D;;AAEA,sBAAsB;AACtB;EACE,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,yCAAyC;AAC3C;;AAEA;EACE,qBAAqB,EAAE,+BAA+B;AACxD;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,mBAAmB;EACnB,iBAAiB;AACnB;;;;;AAKA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,YAAY;EACZ,aAAa;EACb,8BAA8B;EAC9B,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,yCAAyC;AAC3C;;;;AAIA;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,8BAA8B,EAAE,qDAAqD;EACrF,0BAA0B;AAC5B;;AAEA,qCAAqC;AACrC;AACA,aAAa;AACb,6BAA6B;AAC7B,WAAW;AACX,eAAe;AACf,eAAe;AACf;;AAEA;AACA,aAAa,EAAE,4CAA4C;AAC3D,mBAAmB,EAAE,4BAA4B;AACjD,uBAAuB,EAAE,yBAAyB;AAClD,QAAQ,EAAE,gCAAgC;;AAE1C,SAAO,EAAE,sCAAsC;AAC/C,kBAAkB;AAClB,kBAAkB,EAAE,qBAAqB;AACzC,eAAe;AACf,mBAAmB;;AAEnB,YAAY;AACZ,eAAe;AACf,iBAAiB;AACjB,8BAA8B;AAC9B,kBAAkB;AAClB,gCAAgC;AAChC,gBAAgB,EAAE,wBAAwB;AAC1C;;AAEA;AACA,mBAAmB;AACnB;;AAEA;AACA,WAAW,EAAE,qBAAqB;AAClC,YAAY;AACZ;AACA;AACA,aAAa;AACb,uBAAuB;AACvB,SAAS,EAAE,iCAAiC;AAC5C,kBAAkB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS,EAAE,uBAAuB;EAClC,gBAAgB;EAChB,gBAAgB,EAAE,iBAAiB;AACrC;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS,EAAE,kCAAkC;AAC/C;;AAEA,iBAAiB;AACjB;EACE,iBAAiB;EACjB,YAAY,EAAE,uBAAuB;EACrC,iBAAiB,EAAE,wBAAwB;AAC7C;;AAEA,uCAAuC;AACvC;EACE,SAAO,EAAE,gCAAgC;EACzC,aAAa;EACb,sBAAsB;EACtB,kBAAkB;AACpB;;;AAGA;EACE,mBAAmB,EAAE,qCAAqC;EAC1D,mBAAmB,EAAE,4BAA4B;AACnD;;AAEA,0DAA0D;AAC1D;AACA,aAAa;AACb,6BAA6B;AAC7B,eAAe;AACf;;AAEA;AACA,gBAAgB;AAChB,YAAY;AACZ,eAAe;AACf,eAAe;AACf,kBAAkB;AAClB,mBAAmB;AACnB,iBAAiB;AACjB;;AAEA;AACA,WAAW;AACX,cAAc;AACd,WAAW;AACX,WAAW;AACX,uBAAuB;AACvB,kBAAkB;AAClB,SAAS;AACT,OAAO;AACP;AACA;EACE,WAAW,EAAE,qBAAqB;EAClC,YAAY;AACd;AACA,kBAAkB;AAClB;EACE,cAAc;EACd,WAAW;EACX,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;AACA,aAAa;AACb,yBAAyB,GAAG,+BAA+B;AAC3D,qBAAqB,OAAO,iCAAiC;AAC7D,aAAa;AACb,SAAS,GAAG,iCAAiC;AAC7C,YAAY,GAAG,+BAA+B;AAC9C,WAAW,IAAI,sCAAsC;AACrD,UAAU,IAAI,mCAAmC;AACjD;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,kBAAkB;EAClB,yBAAyB,EAAE,eAAe;EAC1C,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,eAAe;EACf,aAAa;AACf;;AAEA;EACE,WAAW;AACb;;AAEA,2BAA2B;AAC3B,2BAA2B;AAC3B;AACA,WAAW;AACX,eAAe;AACf,iBAAiB;AACjB,mBAAmB;AACnB,mBAAmB;AACnB,0CAA0C;AAC1C,iBAAiB,EAAE,kBAAkB;AACrC,kBAAkB;AAClB,sBAAsB;AACtB;;AAEA,kBAAkB;AAClB;EACE,mBAAmB,EAAE,oDAAoD;AAC3E,WAAW;AACX,yBAAyB;AACzB,uBAAuB;AACvB,kBAAkB;AAClB,kBAAkB,EAAE,iCAAiC;AACrD;AACA;EACE,eAAe;EACf,iBAAiB,EAAE,4BAA4B;EAC/C,gBAAgB;EAChB,kBAAkB,EAAE,iCAAiC;AACvD;AACA,8DAA8D;AAC9D;;;gCAGgC,uBAAuB;EACrD,gBAAgB,EAAE,8BAA8B;EAChD,gBAAgB,EAAE,4BAA4B;EAC9C,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB,EAAE,4BAA4B;AAClD;;AAEA,mCAAmC;AACnC;;EAEE,6BAA6B,EAAE,qCAAqC;EACpE,kBAAkB;EAClB,SAAS,EAAE,2BAA2B;EACtC,OAAO;EACP,sBAAsB;EACtB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,mBAAmB,EAAE,mCAAmC;EACxD,gBAAgB,EAAE,wBAAwB;EAC1C,qBAAqB,EAAE,qBAAqB;EAC5C,wCAAwC;AAC1C;AACA,kBAAkB;AAClB;AACA,uBAAuB;AACvB,YAAY;AACZ,iBAAiB;AACjB,gBAAgB;AAChB,MAAM,GAAG,iBAAiB;AAC1B,WAAW,EAAE,8BAA8B;AAC3C;;AAEA;EACE,WAAW;EACX,yBAAyB,EAAE,2BAA2B;AACxD;;AAEA;;EAEE,sBAAsB,EAAE,8BAA8B;AACxD;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,yBAAyB,EAAE,wCAAwC;AACrE;;AAEA,oBAAoB;AACpB;AACA,gBAAgB,EAAE,+BAA+B;AACjD,iBAAiB;AACjB;;AAEA,oBAAoB;AACpB;AACA,gCAAgC;AAChC;;AAEA;AACA,yBAAyB,EAAE,0BAA0B;AACrD;;AAEA;AACA,yBAAyB;AACzB;;AAEA,qBAAqB;AACrB;AACA,YAAY;AACZ,kBAAkB;AAClB,eAAe,EAAE,sBAAsB;AACvC,sBAAsB,EAAE,eAAe;AACvC,mBAAmB,EAAE,sBAAsB;AAC3C,gBAAgB;AAChB,uBAAuB;AACvB;;AAEA,gCAAgC;AAChC;AACA,YAAY;AACZ;;AAEA,kBAAkB;AAClB;AACA,yBAAyB;AACzB,YAAY;AACZ,iBAAiB;AACjB,eAAe;AACf,iBAAiB;AACjB,kBAAkB;AAClB,YAAY;AACZ,eAAe;AACf,gBAAgB;AAChB;;AAEA;AACA,yBAAyB;AACzB;;AAEA,yBAAyB;AACzB;AACA,yBAAyB,EAAE,UAAU;AACrC,YAAY;AACZ,iBAAiB;AACjB,eAAe;AACf,iBAAiB;AACjB,kBAAkB;AAClB,YAAY;AACZ,eAAe;AACf,gBAAgB;AAChB;;AAEA;AACA,yBAAyB;AACzB;;AAEA,4BAA4B;AAC5B;AACA,kBAAkB;AAClB,kBAAkB;AAClB,WAAW;AACX,aAAa;AACb;AACA,uBAAuB;AACvB,uBAAuB;AACvB;AACA,aAAa;AACb,mBAAmB;AACnB,8BAA8B,EAAE,+BAA+B;AAC/D,SAAS;AACT,gBAAgB,GAAG,gCAAgC;AACnD,gBAAgB,GAAG,iCAAiC;AACpD,mBAAmB;AACnB,gBAAgB;AAChB;;AAEA,qBAAqB;AACrB;AACA,YAAY;AACZ,cAAc,EAAE,iDAAiD;AACjE,mBAAmB;AACnB,gBAAgB;AAChB,uBAAuB,EAAE,mCAAmC;AAC5D;;AAEA,kBAAkB;AAClB;AACA,cAAc,GAAG,mCAAmC;AACpD,eAAe;AACf,iBAAiB;AACjB,eAAe;AACf,iBAAiB;AACjB,yBAAyB;AACzB,YAAY;AACZ,YAAY;AACZ,kBAAkB;AAClB,eAAe;AACf;;;;;AAKA;AACA,yBAAyB;AACzB;;AAEA,qBAAqB;;;;AAIrB,8BAA8B;AAC9B;AACA,WAAW;AACX,iBAAiB;AACjB,iBAAiB;AACjB,aAAa;AACb,mBAAmB;AACnB,mBAAmB;AACnB,0CAA0C;AAC1C;;AAEA,kBAAkB;AAClB;AACA,WAAW;AACX,yBAAyB,EAAE,wCAAwC;AACnE,uBAAuB;AACvB,kBAAkB;AAClB,gBAAgB;AAChB,0CAA0C;AAC1C,sBAAsB,EAAE,iBAAiB;AACzC;;AAEA,iBAAiB;AACjB;AACA,yBAAyB;AACzB,YAAY;AACZ,iBAAiB;AACjB;;AAEA,2BAA2B;AAC3B;;AAEA,aAAa;AACb,gBAAgB;AAChB,sBAAsB,EAAE,eAAe;AACvC;;AAEA,oBAAoB;AACpB;AACA,gCAAgC;AAChC;;AAEA;AACA,yBAAyB;AACzB;;AAEA,mBAAmB;AACnB;AACA,yBAAyB;AACzB,YAAY;AACZ,iBAAiB;AACjB,YAAY;AACZ,kBAAkB;AAClB,eAAe;AACf,iBAAiB;AACjB,gBAAgB;AAChB;;AAEA;AACA,yBAAyB;AACzB;;AAEA,2BAA2B;AAC3B;AACA,kBAAkB;AAClB,kBAAkB;AAClB,WAAW;AACX,aAAa;AACb;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,WAAW;AACb;AACA,6BAA6B;AAC7B;AACA,SAAO;AACP,aAAa;AACb;;AAEA;AACA,WAAW;AACX,aAAa;AACb,sBAAsB;AACtB,kBAAkB;AAClB,iBAAiB;AACjB,eAAe;AACf;;;;;;AAMA,sCAAsC;AACtC;AACA,eAAe;AACf,MAAM;AACN,OAAO;AACP,WAAW;AACX,YAAY;AACZ,8BAA8B;AAC9B,aAAa;AACb,uBAAuB;AACvB,mBAAmB;AACnB,aAAa;AACb,gBAAgB,EAAE,kCAAkC;AACpD;;AAEA,qDAAqD;AACrD;AACA,mBAAmB;AACnB,aAAa,EAAE,oBAAoB;AACnC,cAAc,EAAE,oCAAoC;AACpD,gBAAgB,EAAE,oCAAoC;AACtD,aAAa;AACb,kBAAkB;AAClB,yCAAyC;AACzC,kBAAkB;AAClB,gBAAgB;AAChB,gBAAgB,EAAE,qBAAqB;AACvC;AACA;AACA,yBAAyB;AACzB,aAAa;AACb,YAAY;AACZ,eAAe;AACf,kBAAkB;AAClB,iBAAiB;AACjB,mBAAmB;;AAEnB,2CAA2C;AAC3C,8BAA8B,EAAE,kCAAkC;AAClE,aAAa,EAAE,wCAAwC;;AAEvD,gCAAgC;AAChC,kBAAkB;AAClB;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,qCAAqC,EAAE,gBAAgB;EACvD,SAAS,EAAE,yBAAyB;EACpC,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf,sBAAsB;AACtB,QAAQ,EAAE,kCAAkC;AAC5C,mBAAmB,EAAE,8BAA8B;AACnD;AACA,sBAAsB;AACtB;AACA,iBAAiB;AACjB,eAAe;AACf,WAAW;AACX;;AAEA,mDAAmD;AACnD;;;AAGA,aAAa;AACb,sBAAsB;AACtB,kBAAkB;AAClB,eAAe;AACf,mCAAmC;AACnC;;AAEA,qBAAqB;AACrB;;;AAGA,qBAAqB;AACrB;;AAEA,iBAAiB;AACjB;;;AAGA,qBAAqB;AACrB,aAAa;AACb,yCAAyC;AACzC;;AAEA,kCAAkC;AAClC;AACA,YAAY;AACZ,gBAAgB;AAChB;AACA,qCAAqC;AACrC;EACE,mBAAmB,EAAE,iCAAiC;AACxD;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,SAAS;AACX;;AAEA,mBAAmB;AACnB;;;EAGE,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;AACb;;AAEA,kCAAkC;AAClC;EACE,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,eAAe;EACf,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;;;;AAKA,4DAA4D;AAC5D;AACA,iBAAiB,EAAE,8BAA8B;AACjD,gBAAgB,EAAE,uBAAuB;AACzC,sBAAsB;AACtB,kBAAkB;AAClB;;AAEA,uCAAuC;AACvC;AACA,aAAa;AACb,mBAAmB;AACnB,8BAA8B;AAC9B,SAAS;AACT,mBAAmB;AACnB;;AAEA;AACA,iBAAiB;AACjB,YAAY,EAAE,0BAA0B;AACxC;;AAEA;;;AAGA,SAAO;AACP,YAAY;AACZ,sBAAsB;AACtB,kBAAkB;AAClB,yBAAyB,EAAE,sCAAsC;AACjE;;AAEA,YAAY;AACZ;AACA,aAAa;AACb,yBAAyB;AACzB,SAAS;AACT,gBAAgB;AAChB,kBAAkB;AAClB,iBAAiB;AACjB;AACA;EACE,oCAAoC;AACtC;;AAEA;AACA,iBAAiB;AACjB,YAAY;AACZ,eAAe;AACf,kBAAkB;AAClB,eAAe;AACf,yBAAyB,EAAE,iBAAiB;;AAE5C;;AAEA;AACA,sBAAsB;AACtB,uBAAuB,EAAE,iBAAiB;;AAE1C;;AAEA;AACA,yBAAyB;AACzB,YAAY;AACZ;;;;AAIA;AACA,aAAa;AACb,UAAU;AACV,mBAAmB;AACnB,uBAAuB;AACvB,eAAe;AACf;;AAEA;;;AAGA,SAAO;AACP,gBAAgB;AAChB;;AAEA;AACA,cAAc;AACd,iBAAiB;AACjB,yBAAyB;AACzB,YAAY;AACZ,YAAY;AACZ,eAAe;AACf,kBAAkB;AAClB;;AAEA;;AAEA,aAAa;AACb,oDAAoD,EAAE,yBAAyB;AAC/E,SAAS;AACT,mBAAmB;AACnB,mBAAmB;AACnB;;AAEA;AACA,iBAAiB;AACjB,YAAY;AACZ,kBAAkB;AAClB;;AAEA;;;AAGA,WAAW;AACX,YAAY;AACZ,eAAe;AACf,sBAAsB;AACtB,kBAAkB;AAClB;;AAEA;AACA,YAAY;AACZ,YAAY;AACZ;;;;;;;AAOA;AACA,yBAAyB,EAAE,yBAAyB;AACpD,YAAY,EAAE,mBAAmB;AACjC,aAAa,EAAE,gBAAgB;AAC/B,kBAAkB,EAAE,oBAAoB;AACxC,kBAAkB,EAAE,wBAAwB;AAC5C,mBAAmB,EAAE,oBAAoB;AACzC;;;;;;;AAOA,+BAA+B;AAC/B;AACA,yBAAyB;AACzB,aAAa;AACb,kBAAkB;AAClB,0CAA0C;AAC1C,gBAAgB;AAChB,WAAW;AACX,YAAY;AACZ,kBAAkB;AAClB,sBAAsB;AACtB,eAAe;AACf,QAAQ;AACR,SAAS;AACT,gCAAgC;AAChC,aAAa;AACb;;AAEA,iBAAiB;AACjB;AACA,yBAAyB;AACzB,YAAY;AACZ,aAAa;AACb,kBAAkB;AAClB,eAAe;AACf,kBAAkB;AAClB,iBAAiB;AACjB,mBAAmB;AACnB;;AAEA,gBAAgB;AAChB;AACA,aAAa;AACb,sBAAsB;AACtB,SAAS;AACT;;AAEA,WAAW;AACX;AACA,iBAAiB;AACjB,eAAe;AACf,WAAW;AACX,gBAAgB;AAChB,cAAc;AACd,kBAAkB;AAClB;;AAEA,iBAAiB;AACjB;AACA,aAAa;AACb,sBAAsB;AACtB,kBAAkB;AAClB,eAAe;AACf,UAAU;AACV,mCAAmC;AACnC;;AAEA,gCAAgC;AAChC;AACA,qBAAqB;AACrB;;AAEA;AACA,qBAAqB;AACrB,aAAa;AACb,yCAAyC;AACzC;;;;AAIA,sDAAsD;;;AAGtD,gDAAgD;AAChD;AACA,aAAa;AACb,mBAAmB,EAAE,2BAA2B;AAChD,yBAAyB,EAAE,gCAAgC;AAC3D,mBAAmB;AACnB,SAAS,EAAE,0BAA0B;AACrC,YAAY;AACZ,WAAW;AACX;;AAEA,gBAAgB;AAChB;AACA,yBAAyB,EAAE,UAAU;AACrC,YAAY;AACZ,kBAAkB;AAClB,eAAe;AACf,iBAAiB;AACjB,kBAAkB;AAClB,YAAY;AACZ,eAAe;AACf,gBAAgB;AAChB,gBAAgB;AAChB,kBAAkB;AAClB;;AAEA;AACA,yBAAyB;AACzB;;AAEA,kBAAkB;AAClB;AACA,yBAAyB,EAAE,eAAe;AAC1C,oBAAoB;AACpB,kBAAkB;AAClB,eAAe;AACf,iBAAiB;AACjB,kBAAkB;AAClB,kCAAkC,EAAE,iBAAiB;AACrD,eAAe;AACf,gBAAgB;AAChB,gBAAgB;AAChB,kBAAkB;AAClB;;AAEA;AACA,yBAAyB,EAAE,6BAA6B;AACxD;;;AAGA,4BAA4B;AAC5B;AACA,WAAW;AACX,cAAc;AACd,iBAAiB;AACjB,aAAa;AACb,mBAAmB;AACnB,mBAAmB;AACnB,0CAA0C;AAC1C,gBAAgB,EAAE,2CAA2C;AAC7D,kBAAkB;AAClB;;AAEA,UAAU;AACV;AACA,kBAAkB;AAClB,eAAe;AACf,cAAc;AACd,mBAAmB;AACnB;;AAEA,kBAAkB;AAClB;AACA,WAAW;AACX,yBAAyB,EAAE,8BAA8B;AACzD,uBAAuB;AACvB,kBAAkB;AAClB,gBAAgB;AAChB,0CAA0C;AAC1C,sBAAsB,EAAE,iBAAiB;AACzC;;AAEA,iBAAiB;AACjB;AACA,yBAAyB,EAAE,qBAAqB;AAChD,YAAY;AACZ,iBAAiB;AACjB;;AAEA;AACA,aAAa;AACb,kBAAkB;AAClB,sBAAsB,EAAE,eAAe;AACvC;;AAEA,oBAAoB;AACpB;AACA,gCAAgC;AAChC;;AAEA;AACA,yBAAyB,EAAE,0BAA0B;AACrD;;AAEA;AACA,yBAAyB;AACzB;;AAEA,qBAAqB;AACrB;AACA,aAAa;AACb,kBAAkB;AAClB,sBAAsB,EAAE,eAAe;AACvC,eAAe;AACf,gBAAgB;AAChB,WAAW;AACX;;AAEA,0BAA0B;AAC1B;AACA,kBAAkB;AAClB,kBAAkB;AAClB,WAAW;AACX,aAAa;AACb;;;;AAIA,sBAAsB;AACtB;AACA;EACE,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,WAAW;AACb;AACA;;AAEA;AACA,uBAAuB;AACvB,kCAAkC;AAClC;;;AAGA;AACA,aAAa,WAAW,kCAAkC;AAC1D,mBAAmB,KAAK,sCAAsC;AAC9D,SAAS,cAAc,uCAAuC;AAC9D,mBAAmB,IAAI,sBAAsB;AAC7C;;AAEA;AACA,iBAAiB;AACjB,yBAAyB,EAAE,oBAAoB;AAC/C,YAAY;AACZ,YAAY;AACZ,kBAAkB;AAClB,eAAe;AACf,gCAAgC;AAChC;;AAEA;AACA,yBAAyB,EAAE,yBAAyB;AACpD;;AAEA;AACA,yBAAyB,EAAE,kCAAkC;AAC7D;;AAEA;AACA,aAAa;AACb,mBAAmB;AACnB,QAAQ,EAAE,gCAAgC;AAC1C,yBAAyB,EAAE,UAAU;AACrC,YAAY;AACZ,iBAAiB;AACjB,eAAe;AACf,iBAAiB;AACjB,kBAAkB;AAClB,YAAY;AACZ,eAAe;AACf,gBAAgB;AAChB;;AAEA;AACA,yBAAyB;AACzB;;;;AAIA;AACA,aAAa;AACb,mBAAmB;AACnB,QAAQ,EAAE,gCAAgC;AAC1C,yBAAyB;AACzB,YAAY;AACZ,iBAAiB;AACjB,eAAe;AACf,iBAAiB;AACjB,kBAAkB;AAClB,YAAY;AACZ,eAAe;AACf,gBAAgB;AAChB;;AAEA;AACA,yBAAyB;AACzB;;;AAGA;EACE,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB,EAAE,0CAA0C;AACvE","sourcesContent":["/* .asset-summary-buttons2 {\n  display: flex;\n  gap: 20px;\n  flex-wrap: wrap;\n  justify-content: flex-start; /* Aligns items to the left \n  margin-top: 30px;\n  padding: 0;         /* Removes internal space \n  margin-top: 30px;\n  margin-left:60px; \n} */\n .assets-required-asterisk {\n  color: red!important;\n  font-weight: lighter;\n  margin-left: 2px;\n}\n.error-message {\n  color: red!important;\n  font-size: 12px;\n  margin-top: 4px;\n  display: block;\n}\n.asset-summary-buttons2 {\n  display: flex;\n  justify-content: space-between; /* Left group + right button */\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 20px;\n  margin: 30px 60px 0 0px;\n  padding: 0;\n}\n.assetsmain-close-btn-addasset {\n  background: none;\n  border: none;\n  cursor: pointer;\n  position: absolute;\n  top: 12px;\n  right: 12px;\n  padding: 0;\n}\n\n.assetsmain-close-popup-icon {\n  font-size: 24px;\n  color: #fff;\n  transition: color 0.3s ease;\n}\n\n.assetsmain-close-popup-icon:hover {\n  color: red;\n}\n\n\n.close-button-assign-asset {\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 0;\n  display: flex;\n  align-items: center;\n}\n\n.assign-close-popup-icon {\n  font-size: 24px;\n  color: #fff;\n  transition: color 0.3s ease;\n}\n\n.assign-close-popup-icon:hover {\n  color: red;\n}\n\n\n\n\n.left-buttons {\n  display: flex;\n  gap: 12px;\n  flex-wrap: wrap;\n  margin-top:5%;\n}\n\n.right-button {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  margin-top:5%;\n  padding:10px 12px;\n}\n.add-assets-btn {\n  background-color: #7FBD2C;\n  color: white;\n  padding: 10px 12px;\n  border: none;\n  cursor: pointer;\n  font-size: 13px;\n  border-radius: 6px;\n  height: 34px;\n  display: flex;\n  align-items: center;\n  gap: 5px;\n}\n\n.asset-summary-container {\n  max-width: 50%;\n  padding: 10px;\n  box-sizing: border-box;\n  margin-left: auto; /* moves it to the right */\n  margin-right: 0px; /* optional spacing from the right edge */\n}\n\n\n\n.category-button-wrapper {\n  position: relative;\n}\n\n.category-button {\n  padding: 12px 20px;\n  background-color: white;\n  color: rgb(31, 24, 24);\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 16px;\n  transition: background-color 0.3s;\n}\n.total-assets-box {\n  font-size: 16px;\n  font-weight: 500;\n  padding: 6px 12px;\n  border: 1px solid #7FBD2C;\n  background-color: #f1fae8;\n  border-radius: 6px;\n  color: rgb(31, 24, 24);\n  height: 30px;\n  display: flex;\n  align-items: center;\n}\n.category-button:hover {\n  background-color: #7FBD2C;\n}\n\n/* Tooltip for Subcategories */\n.subcategory-tooltip {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  margin-top: 8px;\n  background-color: rgb(228, 235, 230);\n  color: black;\n  border: 1px solid #ccc;\n  border-radius: 6px;\n  padding: 10px;\n  box-shadow: 0 2px 6px rgba(0,0,0,0.15);\n  display: none;\n  white-space: nowrap;\n  z-index: 40;\n}\n\n.category-button-wrapper:hover .subcategory-tooltip {\n  display: block;\n}\n\n.subcategory-item {\n  padding: 4px 8px;\n  font-size: 14px;\n}\n\n.assets-container {\n  max-width: 1200px;  /* You can reduce this to 800px or 600px as needed */\n  margin: 0 auto;      /* Centers the container */\n  padding: 0px;       /* Smaller padding */\n  border-radius: 8px;\n}\n\n\n/* Style for the caption container */\n.table-caption {\n  caption-side: top;\n  padding: 10px;\n  text-align: left;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n/* Label styling */\n.asset-table-search-label {\n  font-weight: 600;\n  font-size: 14px;\n  margin-right: 8px; /* 👈 adds space between label and input */\n\n}\n\n/* Input box styling */\n.asset-table-search-input {\n  padding: 10px 10px;\n  font-size: 14px;\n  border-radius: 4px;\n  border: 1px solid #ccc;\n  width: 200px;\n  outline: none;\n  transition: border-color 0.2s ease-in-out;\n}\n\n.asset-table-search-input:focus {\n  border-color: #28a745; /* soft green border on focus */\n}\n.asset-search-container {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  gap: 10px;\n  margin-top:20px;\n  margin-bottom:-30px;\n  margin-left:-10px;\n}\n\n\n\n\n.asset-popup-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  background: rgba(0, 0, 0, 0.4);\n  z-index: 1000;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.asset-popup-content {\n  background: #E8E9EA;\n  padding: 20px;\n  border-radius: 10px;\n  width: 600px;\n  max-width: 90%;\n  max-height: 90vh;\n  overflow-y: auto;\n  position: relative;\n  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);\n}\n\n\n\n.asset-popup-header {\n  background-color: #00468C;\n  color: white;\n  padding: 12px 20px;\n  font-size: 20px;\n  font-weight: bold;\n  text-align: center;\n  margin: -20px -20px 20px -20px; /* negative margins to cancel out container padding */\n  border-radius: 8px 8px 0 0;\n}\n\n/* Sticky Options (Main Categories) */\n.sticky-options {\ndisplay: flex;\njustify-content: space-around;\nwidth: auto;\npadding: 12px 0;\nfont-size: 18px;\n}\n\n.sticky-options button {\ndisplay: flex; /* Ensure the icon and text align properly */\nalign-items: center; /* Vertically center items */\njustify-content: center; /* Center icon and text */\ngap: 8px; /* Space between icon and text */\n\nflex: 1; /* Make all buttons take equal space */\ntext-align: center;\npadding: 12px 24px; /* Increase padding */\nfont-size: 18px;\nbackground: #d3d3d3;\n\nborder: none;\ncursor: pointer;\nfont-weight: bold;\nborder-bottom: 3px solid black;\nborder-radius: 5px;\ntransition: all 0.2s ease-in-out;\nmin-width: 150px; /* Set a minimum width */\n}\n\n.sticky-options button:hover {\nbackground: #b3b3b3;\n}\n\n.icon {\nwidth: 24px; /* Adjust icon size */\nheight: 24px;\n}\n.icon-group {\ndisplay: flex;\njustify-content: center;\ngap: 10px; /* Space between multiple icons */\nmargin-bottom: 5px;\n}\n\n.asset-details-grid {\n  display: flex;\n  flex-direction: column;\n  gap: 15px; /* Space between rows */\n  margin-top: 15px;\n  max-width: 600px; /* Adjust width */\n}\n\n/* Each row has label and input */\n.row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 20px; /* Space between label and input */\n}\n\n/* Style labels */\n.row label {\n  font-weight: bold;\n  width: 150px; /* Adjust label width */\n  text-align: right; /* Align text to right */\n}\n\n/* Ensure input fields align properly */\n.row input {\n  flex: 1; /* Inputs take available space */\n  padding: 10px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n}\n\n\n.sticky-options button.active {\n  border-bottom: none; /* Remove bottom border when active */\n  background: #b0b0b0; /* Darker gray when active */\n}\n\n/* Sub-options (without box, only underline when active) */\n.sticky-suboptions {\ndisplay: flex;\njustify-content: space-around;\npadding: 10px 0;\n}\n\n.sticky-suboptions button {\nbackground: none;\nborder: none;\nfont-size: 16px;\ncursor: pointer;\nposition: relative;\npadding-bottom: 5px;\nfont-weight: bold;\n}\n\n.sticky-suboptions button.active::after {\ncontent: \"\";\ndisplay: block;\nwidth: 100%;\nheight: 3px;\nbackground-color: black;\nposition: absolute;\nbottom: 0;\nleft: 0;\n}\n.sticky-suboptions button .icon {\n  width: 20px; /* Adjust as needed */\n  height: 20px;\n}\n/* Asset Details */\n.asset-details input {\n  display: block;\n  width: 100%;\n  margin: 12px 0;\n  padding: 10px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n}\n\n.popup-buttons {\ndisplay: flex;\njustify-content: flex-end;  /* Moves buttons to the right */\nalign-items: flex-end;      /* Aligns buttons at the bottom */\npadding: 15px;\ngap: 10px;  /* Adds spacing between buttons */\nbottom: 10px;  /* Ensures it's at the bottom */\nright: 10px;   /* Ensures it's aligned to the right */\nwidth: 98%;   /* Ensures full width for spacing */\n}\n\n.cancel-btn {\n  background-color: #ddd;\n  color: rgb(14, 7, 7);\n  padding: 10px 18px;\n  border: 1px solid #7FBD2C; /* Grid lines */\n  border-radius: 5px;\n  cursor: pointer;\n  font-size: 16px;\n}\n\n.save-btn {\n  background-color: #7FBD2C;\n  color: white;\n  padding: 10px 18px;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n  font-size: 16px;\n}\n\n.close-btn-addasset {\n  position: absolute;\n  top: 10px;\n  right: 30px;\n  background: transparent;\n  border: none;\n  font-size: 24px;\n  font-weight: bold;\n  color: white;\n  cursor: pointer;\n  z-index: 1000;\n}\n\n.close-btn-addasset:hover {\n  color: #000;\n}\n\n/* Assets Table Container */\n/* Assets Table Container */\n.assets-table {\nwidth: 100%;\nmax-width: 100%;\nmargin: 20px auto;\nbackground: #f9f9f9;\nborder-radius: 10px;\nbox-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);\nmax-height: 450px; /* Adjust height */\nposition: relative;\nborder: 1px solid #ddd;\n}\n\n/* Table Styling */\n.assets-table table {\n  table-layout: fixed; /* Prevents columns from resizing based on content */\nwidth: 100%;\nborder-collapse: collapse;\nbackground-color: white;\nborder-radius: 8px;\ntable-layout: auto; /* Ensures correct column width */\n}\n.assets-table-wrapper {\n  margin-top:20px;\n  max-height: 300px; /* Adjust height as needed */\n  overflow-y: auto;\n  overflow-x: hidden; /* Prevent horizontal scrolling */\n}\n/* Specific styling for Asset Name and Configuration columns */\n.assets-table th:nth-child(3), /* Asset Name header */\n.assets-table td:nth-child(3), /* Asset Name cell */\n.assets-table th:nth-child(4), /* Configuration header */\n.assets-table td:nth-child(4) { /* Configuration cell */\n  max-width: 150px; /* Set a fixed maximum width */\n  min-width: 150px; /* Ensure consistent width */\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  position: relative; /* For tooltip positioning */\n}\n\n/* Tooltip for full text on hover */\n.assets-table td:nth-child(3):hover::after,\n.assets-table td:nth-child(4):hover::after {\n  content: attr(data-full-text); /* Use data attribute for full text */\n  position: absolute;\n  top: 100%; /* Display below the cell */\n  left: 0;\n  background-color: #333;\n  color: white;\n  padding: 8px;\n  border-radius: 4px;\n  z-index: 10;\n  white-space: normal; /* Allow text wrapping in tooltip */\n  max-width: 300px; /* Limit tooltip width */\n  word-wrap: break-word; /* Break long words */\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\n}\n/* Sticky Header */\n.assets-table thead {\nbackground-color: white;\ncolor: black;\nfont-weight: bold;\nposition: sticky;\ntop: 0;  /* Stick to top */\nz-index: 10; /* Ensure it's above content */\n}\n\n.assets-table {\n  width: 100%;\n  border-collapse: collapse; /* Ensures single borders */\n}\n\n.assets-table th,\n.assets-table td {\n  border: 1px solid #ccc; /* Apply border to all cells */\n}\n\n.assets-table th {\n  padding: 12px;\n  text-align: center;\n  font-size: 12px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  background-color: #f9f9f9; /* Optional: better visual distinction */\n}\n\n/* Scrollable Body */\n.assets-table tbody {\noverflow-y: auto; /* Enables vertical scrolling */\nmax-height: 400px;\n}\n\n/* Table Body Rows */\n.assets-table tbody tr {\ntransition: background 0.3s ease;\n}\n\n.assets-table tbody tr:nth-child(even) {\nbackground-color: #f2f2f2; /* Alternating row color */\n}\n\n.assets-table tbody tr:hover {\nbackground-color: #e0e0e0;\n}\n\n/* Table Data Cells */\n.assets-table td {\npadding: 3px;\ntext-align: center;\nfont-size: 12px; /* Reduced font size */\nborder: 1px solid #ccc; /* Grid lines */\nwhite-space: nowrap; /* Prevents wrapping */\noverflow: hidden;\ntext-overflow: ellipsis;\n}\n\n/* No Border for Certain Cells */\n.assets-table .no-border {\nborder: none;\n}\n\n/* Assign Button */\n.assets-table .assign-btn {\nbackground-color: #007bff;\ncolor: white;\npadding: 5px 10px;\nfont-size: 12px;\nfont-weight: bold;\nborder-radius: 5px;\nborder: none;\ncursor: pointer;\ntransition: 0.3s;\n}\n\n.assets-table .assign-btn:hover {\nbackground-color: #0056b3;\n}\n\n/* View Document Button */\n.assets-table button {\nbackground-color: #7FBD2C; /* Green */\ncolor: white;\npadding: 5px 10px;\nfont-size: 12px;\nfont-weight: bold;\nborder-radius: 5px;\nborder: none;\ncursor: pointer;\ntransition: 0.3s;\n}\n\n.assets-table button:hover {\nbackground-color: #7FBD2C;\n}\n\n/* No Assets Available Row */\n.assets-table td[colspan=\"7\"] {\ntext-align: center;\nfont-style: italic;\ncolor: #777;\npadding: 15px;\n}\n/* Assigned To Column */\n/* Assigned To Column */\n.assigned-to-cell {\ndisplay: flex;\nalign-items: center;\njustify-content: space-between; /* Keep name & button aligned */\ngap: 10px;\nmin-width: 200px;  /* Adjust this value if needed */\nmax-width: 300px;  /* Prevent excessive stretching */\nwhite-space: nowrap;\noverflow: hidden;\n}\n\n/* Assigned To Name */\n.assigned-name {\nflex-grow: 1;\nmax-width: 70%; /* Ensures name does not take up too much space */\nwhite-space: nowrap;\noverflow: hidden;\ntext-overflow: ellipsis; /* Adds \"...\" if name is too long */\n}\n\n/* Assign Button */\n.assign-btn {\nflex-shrink: 0;  /* Prevents button from shrinking */\nmin-width: 80px;\npadding: 5px 10px;\nfont-size: 12px;\nfont-weight: bold;\nbackground-color: #007bff;\ncolor: white;\nborder: none;\nborder-radius: 5px;\ncursor: pointer;\n}\n\n\n\n\n.assign-btn:hover {\nbackground-color: #0056b3;\n}\n\n/* Responsive Table */\n\n\n\n/* Assigned Assets Container */\n.assigned-assets-container {\nwidth: 100%;\nmax-width: 1200px;\nmargin: 20px auto;\npadding: 20px;\nbackground: #f9f9f9;\nborder-radius: 10px;\nbox-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);\n}\n\n/* Table Styling */\n.assigned-assets-table {\nwidth: 100%;\nborder-collapse: collapse; /* Ensures grid lines appear correctly */\nbackground-color: white;\nborder-radius: 8px;\noverflow: hidden;\nbox-shadow: 0px 2px 6px rgba(0, 0, 0, 0.1);\nborder: 2px solid #ddd; /* Outer border */\n}\n\n/* Table Header */\n.assigned-assets-table thead {\nbackground-color: #00468C;\ncolor: white;\nfont-weight: bold;\n}\n\n/* Table Header and Cells */\n.assigned-assets-table th,\n.assigned-assets-table td {\npadding: 12px;\ntext-align: left;\nborder: 1px solid #ccc; /* Grid lines */\n}\n\n/* Table Body Rows */\n.assigned-assets-table tbody tr {\ntransition: background 0.3s ease;\n}\n\n.assigned-assets-table tbody tr:hover {\nbackground-color: #f1f1f1;\n}\n\n/* Button Styling */\n.assigned-assets-table button {\nbackground-color: #28a745;\ncolor: white;\npadding: 8px 12px;\nborder: none;\nborder-radius: 5px;\ncursor: pointer;\nfont-weight: bold;\ntransition: 0.3s;\n}\n\n.assigned-assets-table button:hover {\nbackground-color: #218838;\n}\n\n/* No Assigned Assets Row */\n.assigned-assets-table td[colspan=\"7\"] {\ntext-align: center;\nfont-style: italic;\ncolor: #777;\npadding: 15px;\n}\n\n.no-data {\n  text-align: center;\n  padding: 20px;\n  font-size: 16px;\n  color: gray;\n}\n/* Adjust dropdown box size */\n.asset-status-dropdown {\nflex: 1;\ndisplay: flex;\n}\n\n.asset-status-dropdown select {\nwidth: 100%;\npadding: 10px;\nborder: 1px solid #ccc;\nborder-radius: 4px;\nbackground: white;\nfont-size: 16px;\n}\n\n\n\n\n\n/* Overlay to cover the whole screen */\n.assignpopup-overlay {\nposition: fixed;\ntop: 0;\nleft: 0;\nwidth: 100%;\nheight: 100%;\nbackground: rgba(0, 0, 0, 0.5);\ndisplay: flex;\njustify-content: center;\nalign-items: center;\nz-index: 1000;\noverflow: hidden; /* Prevents background scrolling */\n}\n\n/* Popup content with increased width and scrolling */\n.assignpopup-content {\nbackground: #E8E9EA;\nwidth: 1000px; /* Increased width */\nmax-width: 95%; /* Ensures it fits smaller screens */\nmax-height: 50vh; /* Set max height to avoid cutting */\npadding: 20px;\nborder-radius: 0px;\nbox-shadow: 0 4px 10px rgba(0, 0, 0, 0.3);\nposition: relative;\ntext-align: left;\noverflow-y: auto; /* Enable scrolling */\n}\n.assignpopup-content h3 {\nbackground-color: #00468C;\npadding: 12px;\ncolor: white;\nfont-size: 20px;\ntext-align: center;\nfont-weight: bold;\nmargin-bottom: 15px;\n\n/* Make the header stretch across the top */\nmargin: -20px -20px 15px -20px; /* Pull edges to touch the sides */\npadding: 15px; /* Increase padding for better spacing */\n\n/* Rounded bottom corners only */\nborder-radius: 0px;\n}\n\n/* Grid layout for form */\n.assetform-grid {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr); /* Two columns */\n  gap: 20px; /* Space between fields */\n  margin-bottom: 10px;\n}\n\n.assetform-field {\n  display: flex;\nflex-direction: column;\ngap: 5px; /* Space between label and input */\nmargin-bottom: 10px; /* Space between form fields */\n}\n/* Styling the label */\n.assetform-field label {\nfont-weight: bold;\nfont-size: 14px;\ncolor: #333;\n}\n\n/* Styling the input fields, select, and textarea */\n.assetform-field input,\n.assetform-field select,\n.assetform-field textarea {\npadding: 10px;\nborder: 1px solid #ccc;\nborder-radius: 5px;\nfont-size: 14px;\ntransition: border 0.3s ease-in-out;\n}\n\n/* Add hover effect */\n.assetform-field input:hover,\n.assetform-field select:hover,\n.assetform-field textarea:hover {\nborder-color: #00468C;\n}\n\n/* Focus effect */\n.assetform-field input:focus,\n.assetform-field select:focus,\n.assetform-field textarea:focus {\nborder-color: #00468C;\noutline: none;\nbox-shadow: 0 0 5px rgba(0, 70, 140, 0.3);\n}\n\n/* Make textarea slightly larger */\n.assetform-field textarea {\nheight: 80px;\nresize: vertical;\n}\n/* Full-width fields (for comments) */\n.assetform-field.full-width {\n  grid-column: span 2; /* Makes it take the full width */\n}\n\n/* Row for asset details */\n.row {\n  display: flex;\n  justify-content: space-between;\n  gap: 15px;\n  margin-bottom: 10px;\n}\n\n.row p {\n  font-weight: bold;\n  margin: 0;\n}\n\n/* Styling inputs */\n.form-field input,\n.form-field select,\n.form-field textarea {\n  padding: 8px;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  width: 100%;\n}\n\n/* Make textarea slightly taller */\n.form-field textarea {\n  height: 80px;\n}\n.close-button-assign-asset {\n  position: absolute;\n  top: 10px;\n  right: 15px;\n  background: transparent;\n  border: none;\n  font-size: 24px;\n  color: white;\n  cursor: pointer;\n  z-index: 1001;\n}\n\n.close-button-assign-asset:hover {\n  color: #ffcccc;\n}\n\n\n\n\n/* Ensure the table inside the popup also scrolls properly */\n.assigned-assets-container {\nmax-height: 350px; /* Increase the table height */\noverflow-y: auto; /* Make it scrollable */\nborder: 1px solid #ddd;\nborder-radius: 5px;\n}\n\n/* Row-wise alignment for form fields */\n.row {\ndisplay: flex;\nalign-items: center;\njustify-content: space-between;\ngap: 15px;\nmargin-bottom: 10px;\n}\n\n.row label {\nfont-weight: bold;\nwidth: 150px; /* Increased label width */\n}\n\n.row input,\n.row select,\n.row textarea {\nflex: 1;\npadding: 8px;\nborder: 1px solid #ccc;\nborder-radius: 5px;\nwidth: calc(100% - 160px); /* Adjust width for better alignment */\n}\n\n/* Buttons */\n.assignpopup-buttons {\ndisplay: flex;\njustify-content: flex-end;\ngap: 10px;\nmargin-top: 25px;\nmargin-bottom:10px;\nmargin-right:50px;\n}\n.decommissioned-row {\n  background-color: #504444 !important;\n}\n\n.assignpopup-buttons button {\npadding: 8px 12px;\nborder: none;\ncursor: pointer;\nborder-radius: 5px;\nfont-size: 14px;\nborder: 1px solid #7FBD2C; /* Black border */\n\n}\n\n.assigncancel-btn {\nbackground-color: #ccc;\nborder: 2px solid black; /* Black border */\n\n}\n\n.assignsave-btn {\nbackground-color: #7FBD2C;\ncolor: white;\n}\n\n\n\n.assetform-row {\ndisplay: flex;\ngap: -10px;\nmargin-bottom: 10px;\nalign-items: flex-start;\nflex-wrap: wrap;\n}\n\n.assetform-row input,\n.assetform-row select,\n.assetform-row textarea {\nflex: 1;\nmin-width: 150px;\n}\n\n.addrow-btn {\nmargin: 10px 0;\npadding: 6px 12px;\nbackground-color: #7FBD2C;\ncolor: white;\nborder: none;\ncursor: pointer;\nborder-radius: 5px;\n}\n\n.assetform-header,\n.assetform-row {\ndisplay: grid;\ngrid-template-columns: 150px 150px 150px 150px 200px; /* One column per field */\ngap: 30px;\nmargin-bottom: 10px;\nalign-items: center;\n}\n\n.assetform-header {\nfont-weight: bold;\npadding: 8px;\nborder-radius: 5px;\n}\n\n.assetform-row input,\n.assetform-row select,\n.assetform-row textarea {\nwidth: 100%;\npadding: 6px;\nfont-size: 14px;\nborder: 1px solid #ccc;\nborder-radius: 4px;\n}\n\n.assetform-row textarea {\nresize: none;\nheight: 30px;\n}\n\n\n\n\n\n\n.returndateform-container h3 {\nbackground-color: #00468C; /* Set background color */\ncolor: white; /* Set text color */\npadding: 10px; /* Add padding */\ntext-align: center; /* Center the text */\nborder-radius: 5px; /* Add rounded corners */\nmargin-bottom: 15px; /* Add space below */\n}\n\n\n\n\n\n\n/* Return Date Form Container */\n.returndateform-container {\nbackground-color: #E8E9EA;\npadding: 20px;\nborder-radius: 0px;\nbox-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);\nmax-width: 400px;\nwidth: 100%;\nmargin: auto;\ntext-align: center;\nborder: 1px solid #ddd;\nposition: fixed;\ntop: 50%;\nleft: 50%;\ntransform: translate(-50%, -50%);\nz-index: 1000;\n}\n\n/* Form Heading */\n.returndateform-container h3 {\nbackground-color: #00468C;\ncolor: white;\npadding: 12px;\nborder-radius: 0px;\nfont-size: 18px;\ntext-align: center;\nfont-weight: bold;\nmargin-bottom: 15px;\n}\n\n/* Form Fields */\n.returndateform-container form {\ndisplay: flex;\nflex-direction: column;\ngap: 15px;\n}\n\n/* Labels */\n.returndateform-container label {\nfont-weight: bold;\nfont-size: 14px;\ncolor: #333;\ntext-align: left;\ndisplay: block;\nmargin-bottom: 5px;\n}\n\n/* Input Fields */\n.returndateform-container input {\npadding: 10px;\nborder: 1px solid #ccc;\nborder-radius: 5px;\nfont-size: 14px;\nwidth: 95%;\ntransition: border 0.3s ease-in-out;\n}\n\n/* Input Focus & Hover Effects */\n.returndateform-container input:hover {\nborder-color: #00468C;\n}\n\n.returndateform-container input:focus {\nborder-color: #00468C;\noutline: none;\nbox-shadow: 0 0 5px rgba(0, 70, 140, 0.3);\n}\n\n\n\n/* Parent container should have relative positioning */\n\n\n/* Buttons Container - Positioned Bottom Right */\n.returndateform-buttons {\ndisplay: flex;\nflex-direction: row; /* Keeps buttons in a row */\njustify-content: flex-end; /* Aligns buttons to the right */\nalign-items: center;\ngap: 10px; /* Space between buttons */\nbottom: 15px;\nright: 15px;\n}\n\n/* Save Button */\n.returndateform-buttons .rsave-btn {\nbackground-color: #28a745; /* Green */\ncolor: white;\npadding: 10px 20px;\nfont-size: 14px;\nfont-weight: bold;\nborder-radius: 5px;\nborder: none;\ncursor: pointer;\ntransition: 0.3s;\nmin-width: 100px;\ntext-align: center;\n}\n\n.returndateform-buttons .rsave-btn:hover {\nbackground-color: #218838;\n}\n\n/* Cancel Button */\n.returndateform-buttons .rcancel-btn {\nbackground-color: #dfd9da; /* Light Grey */\ncolor: rgb(22, 6, 6);\npadding: 10px 20px;\nfont-size: 14px;\nfont-weight: bold;\nborder-radius: 5px;\nborder: 1px solid rgb(29, 119, 37); /* Black border */\ncursor: pointer;\ntransition: 0.3s;\nmin-width: 100px;\ntext-align: center;\n}\n\n.returndateform-buttons .rcancel-btn:hover {\nbackground-color: #c0b6b8; /* Slightly darker on hover */\n}\n\n\n/* Asset Summary Container */\n.asset-summary {\nwidth: 100%;\nmax-width: 90%;\nmargin: 20px auto;\npadding: 20px;\nbackground: #f9f9f9;\nborder-radius: 10px;\nbox-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);\noverflow-x: auto; /* Enables horizontal scrolling if needed */\ntext-align: center;\n}\n\n/* Title */\n.asset-summary h2 {\ntext-align: center;\nfont-size: 22px;\ncolor: #00468C;\nmargin-bottom: 15px;\n}\n\n/* Table Styling */\n.asset-summary table {\nwidth: 100%;\nborder-collapse: collapse; /* Ensures proper grid lines */\nbackground-color: white;\nborder-radius: 8px;\noverflow: hidden;\nbox-shadow: 0px 2px 6px rgba(0, 0, 0, 0.1);\nborder: 2px solid #ddd; /* Outer border */\n}\n\n/* Table Header */\n.asset-summary thead {\nbackground-color: #00468C; /* Dark blue header */\ncolor: white;\nfont-weight: bold;\n}\n\n.asset-summary th {\npadding: 12px;\ntext-align: center;\nborder: 1px solid #ccc; /* Grid lines */\n}\n\n/* Table Body Rows */\n.asset-summary tbody tr {\ntransition: background 0.3s ease;\n}\n\n.asset-summary tbody tr:nth-child(even) {\nbackground-color: #f2f2f2; /* Alternating row color */\n}\n\n.asset-summary tbody tr:hover {\nbackground-color: #e0e0e0;\n}\n\n/* Table Data Cells */\n.asset-summary td {\npadding: 12px;\ntext-align: center;\nborder: 1px solid #ccc; /* Grid lines */\nfont-size: 16px;\nfont-weight: 500;\ncolor: #333;\n}\n\n/* No Data Available Row */\n.asset-summary td[colspan=\"5\"] {\ntext-align: center;\nfont-style: italic;\ncolor: #777;\npadding: 15px;\n}\n\n\n\n/* Mobile Responsive */\n@media (max-width: 768px) {\n.assignpopup-content {\n  width: 95%;\n  max-height: 85vh;\n}\n\n.row {\n  flex-direction: column;\n  align-items: flex-start;\n}\n\n.row label {\n  width: 100%;\n}\n}\n\n.no-border {\nborder: none !important;\nbackground: transparent !important;\n}\n\n\n.no-border {\ndisplay: flex;          /* Makes items appear in one row */\nalign-items: center;    /* Aligns text and button vertically */\ngap: 10px;             /* Adds space between name and button */\nwhite-space: nowrap;   /* Prevents wrapping */\n}\n\n.assign-btn {\npadding: 5px 10px;\nbackground-color: #007bff; /* Blue background */\ncolor: white;\nborder: none;\nborder-radius: 5px;\ncursor: pointer;\ntransition: background 0.3s ease;\n}\n\n.assign-btn:hover {\nbackground-color: #0056b3; /* Darker blue on hover */\n}\n\n.assign-btn:active {\nbackground-color: #004494; /* Even darker blue when clicked */\n}\n\n.view-doc-btn {\ndisplay: flex;\nalign-items: center;\ngap: 5px; /* Space between icon and text */\nbackground-color: #28a745; /* Green */\ncolor: white;\npadding: 5px 10px;\nfont-size: 12px;\nfont-weight: bold;\nborder-radius: 5px;\nborder: none;\ncursor: pointer;\ntransition: 0.3s;\n}\n\n.view-doc-btn:hover {\nbackground-color: #218838;\n}\n\n\n\n.editassign-btn {\ndisplay: flex;\nalign-items: center;\ngap: 5px; /* Space between icon and text */\nbackground-color: #007bff;\ncolor: white;\npadding: 5px 10px;\nfont-size: 12px;\nfont-weight: bold;\nborder-radius: 5px;\nborder: none;\ncursor: pointer;\ntransition: 0.3s;\n}\n\n.editassign-btn:hover {\nbackground-color: #0056b3;\n}\n\n\n.input-style {\n  padding: 6px;\n  border-radius: 4px;\n  border: 1px solid #ccc;\n}\n\n.error-border {\n  border: 1px solid red;\n  background-color: #ffe6e6;\n}\n.view-doc-btn, .download-doc-btn {\n  background-color: #00468C;\n  color: white;\n  border: none;\n  padding: 6px 10px;\n  border-radius: 4px;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n}\n\n.download-doc-btn {\n  background-color: #007B3A; /* Slightly different color for download */\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
